import useScheduleStore from "@/store/schedule";
import { CustomLink } from "@/styles/shared/link/link.style";
import { ActionIcon, Divider, NavLink, Stack } from "@mantine/core";
import {
  IconAppsFilled,
  IconCalendarWeek,
  IconLayoutList,
  IconRowInsertTop,
} from "@tabler/icons-react";

type Props = {
  close: () => void;
};

function ScheduleSideBar({ close }: Props) {
  const { setShowType } = useScheduleStore();
  return (
    <Stack>
      <NavLink
        onClick={() => {
          setShowType({
            showType: "daily",
          });
          close();
        }}
        label="نمایش ساعتی"
        leftSection={
          <ActionIcon variant="subtle" c="gray">
            <IconCalendarWeek />
          </ActionIcon>
        }
      />
      <NavLink
        onClick={() => {
          setShowType({
            showType: "list",
          });
          close();
        }}
        label="نمایش نوبت ها"
        leftSection={
          <ActionIcon variant="subtle" c="gray">
            <IconLayoutList />
          </ActionIcon>
        }
      />
      <Divider />
      <CustomLink to="services">
        <NavLink
          label="خدمات"
          leftSection={
            <ActionIcon variant="subtle" c="gray">
              <IconAppsFilled stroke={1} />
            </ActionIcon>
          }
        />
      </CustomLink>
      <CustomLink to="services/add">
        <NavLink
          label="افزودن خدمات"
          leftSection={
            <ActionIcon variant="subtle" c="gray">
              <IconRowInsertTop stroke={1} />
            </ActionIcon>
          }
        />
      </CustomLink>
    </Stack>
  );
}

export default ScheduleSideBar;
